import React, { useEffect, useState, useRef } from 'react'
import { CardContentProps, CardContent } from './CardContent'
import { FeatureFlagProps } from './FeatureFlag'

/**
 *
 * @param {*} props
 * @returns
 */

export type CardRecord = {
  cardCategory?: string
  cardContent?: CardContentProps
  cardArticle?: CardContentProps
  collapse?: boolean
  featureFlag?: FeatureFlagProps
  cardId?: string
}

export type CardProps = {
  card: CardRecord
  onFocus?: React.FocusEventHandler<HTMLAnchorElement>
}

export const Card = (props: CardProps) => {
  const { card, onFocus } = props
  const { cardCategory, cardArticle, featureFlag, cardContent } = card
  const linkRef = useRef<HTMLAnchorElement>(null)
  const cardValues = cardArticle || cardContent || {}

  const getCardContent = () => {
    const {
      cardDescription,
      heading,
      cardHeadingLevel,
      superHeadline,
      author,
      readTime,
      date,
      cardImage,
      hideImage = 'false',
    } = cardValues
    if (
      !featureFlag &&
      !cardDescription &&
      !heading &&
      !superHeadline &&
      !author &&
      !readTime &&
      !date &&
      !cardImage
    ) {
      return null
    }
    return (
      <div
        className={
          'Card Card--withHeader u-flex u-flexCol u-padding0 u-paddingBottom20 u-posRelative u-bgColorWhite u-sizeFull'
        }
        card-category={cardCategory}>
        <CardContent
          featureFlag={featureFlag}
          cardDescription={cardDescription}
          heading={heading}
          cardHeadingLevel={cardHeadingLevel}
          superHeadline={superHeadline}
          author={author}
          readTime={readTime}
          date={date}
          cardImage={cardImage}
          hideImage={hideImage}
        />
      </div>
    )
  }

  if (cardValues.url) {
    return (
      <a
        href={cardValues.url}
        className='u-linkClean Card-Border'
        data-analytics={cardValues.dataAnalytics}
        onFocus={onFocus}
        ref={linkRef}
        onMouseDown={e => {
          e.stopPropagation()
          e.preventDefault()
        }}>
        {getCardContent()}
      </a>
    )
  }

  return getCardContent()
}
